<template>
  <div>
    <v-container>
      <template>
        <div>
          <v-dialog
            v-model="dialog"
            width="1200px"
            persistent
            :retain-focus="false"
          >
            <v-card class="custom-card" rounded="0">
              <v-toolbar color="primary" class="white--text">
                <v-toolbar-title class="font-weight-bold">
                  {{
                    viewOnly
                      ? $t('esgPlatform.viewAssessmentQuestion')
                      : isEdit
                      ? $t('esgPlatform.editAssessmentQuestion')
                      : $t('esgPlatform.addAssessmentQuestion')
                  }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon class="white--text" @click="closeModal">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-form class="question" lazy-validation autocomplete="off">
                <v-card-text class="black--text">
                  <fieldset :disabled="viewOnly" class="vq-readonly-fieldset">
                  <v-row class="my-4">
                    <v-col class="right-border-col" cols="2">
                      <h3 class="mb-4">{{ $t('esgPlatform.score') }}</h3>
                      <v-row>
                        <v-col>{{ question.scoreEnabled ? $t('esgPlatform.enabled') : $t('esgPlatform.disabled') }}</v-col>
                        <v-col>
                          <v-switch inset class="bottomless pt-0 mt-0"
                            v-model="question.scoreEnabled"
                            :disabled="isQuestionScoreLocked"
                          ></v-switch>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col class="right-border-col pl-8" cols="2">
                      <h3 class="mb-4">{{ $t('esgPlatform.mandatory') }}</h3>
                      <v-row>
                        <v-col>{{ question.isMandatory ? $t('esgPlatform.yes') : $t('esgPlatform.no') }}</v-col>
                        <v-col>
                          <v-switch inset class="bottomless pt-0 mt-0"
                            v-model="question.isMandatory"
                          ></v-switch>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col class="pl-8" cols="4">
                      <div class="mb-2">
                        <span class="h3 mr-1">{{ $t('esgPlatform.whoWillAnswerThisQuestion') }}</span>
                        <v-tooltip top color="00BD73" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                              <v-icon size="medium" class="icon-with-background" style="color:#0EBF67" v-bind="attrs" v-on="on">
                              mdi-alert-circle
                              </v-icon>
                          </template>
                          <span>{{ $t('esgPlatform.whoWillAnswerTooltip') }}</span>
                        </v-tooltip>
                      </div>
                      <v-select
                        class="answerer-select"
                        :items="answererOptions"
                        item-text="label"
                        item-value="value"
                        v-model="question.answerer"
                        dense
                        outlined
                        :clearable="!isQuestionAnswererLocked"
                        :disabled="isQuestionAnswererLocked"
                      >
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row class="my-4">
                    <v-col cols="4">
                      <div class="mb-2">
                        <span class="h3 mr-1">{{ $t('esgPlatform.heading') }}</span>
                        <v-tooltip top color="00BD73" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon size="medium" class="icon-with-background" style="color:#0EBF67" v-bind="attrs" v-on="on">
                              mdi-alert-circle
                            </v-icon>
                          </template>
                          <span>{{ $t('esgPlatform.selectHeadingTooltip') }}</span>
                        </v-tooltip>
                      </div>
                      <v-select
                        :items="headings"
                        v-model="question.esgHeadingId"
                        item-value="_id"
                        item-text="title"
                        dense
                        outlined
                        clearable
                      >
                      </v-select>
                    </v-col>
                    <v-col cols="4">
                      <div class="mb-2">
                        <span class="h3 mr-1">{{ $t('esgPlatform.questionType') }}</span>
                        <v-tooltip top color="00BD73" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                              <v-icon size="medium" class="icon-with-background" style="color:#0EBF67" v-bind="attrs" v-on="on">
                              mdi-alert-circle
                              </v-icon>
                          </template>
                          <span>{{ $t('esgPlatform.typeOfQuestion') }}</span>
                        </v-tooltip>
                      </div>
                      <v-select
                        :items="questionTypeOptions"
                        v-model="question.questionType"
                        item-text="label"
                        item-value="value"
                        dense
                        outlined
                        clearable
                      >
                      </v-select>
                    </v-col>
                    <v-col cols="4">
                    </v-col>
                  </v-row>

                  <div v-if="!isOptionType()">
                    <v-col cols="12" class="px-0">
                      <div class="mb-2">
                        <span class="h3 mr-1">{{ isDimitraModule ? $t('esgPlatform.question') : $t('esgPlatform.questionTitle') }}</span>
                        <v-tooltip top color="00BD73" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                              <v-icon size="medium" class="icon-with-background" style="color:#0EBF67" v-bind="attrs" v-on="on">
                              mdi-alert-circle
                              </v-icon>
                          </template>
                          <span>{{ $t('esgPlatform.titleTooltip') }}</span>
                        </v-tooltip>
                      </div>
                      <v-text-field
                        v-model="question.title"
                        :placeholder="$t('esgPlatform.enterHere')"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3" class="px-0" v-if="hasQuestionLevelScore && !isDimitraModule">
                      <div class="mb-2">
                        <span class="h3 mr-1">{{ $t('esgPlatform.score') }}</span>
                      </div>
                      <v-text-field
                        v-model="question.score"
                        outlined
                        dense
                        type="number"
                        min="0"
                        step="0.01"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" class="px-0" v-if="question.questionType === 'get-data'">
                      <v-card elevation="0" class="gray lighten-4 my-4 px-4 py-4">
                        <v-card elevation="0" class="white">
                          <v-card-text>
                              <v-row>
                                <v-col cols="9">
                                  <h3>{{ $t('esgPlatform.actions') }}</h3>
                                  <v-row>
                                    <v-col>
                                      <v-checkbox
                                        v-model="question.getData. flags.getData"
                                        :label="$t('esgPlatform.getData')"
                                      ></v-checkbox>
                                    </v-col>
                                    <v-col></v-col>
                                  </v-row>
                                </v-col>
                                <v-col class="content-col" cols="3">
                                  <v-row>
                                    <v-col cols="5" class="content-col"><h3>{{ $t('esgPlatform.condition') }}</h3></v-col>
                                    <v-col cols="7">
                                      <v-select
                                        :items="conditions"
                                        v-model="question.getData.condition"
                                        dense
                                        outlined
                                        clearable
                                      >
                                      </v-select>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                              
                              <section v-if="question.getData.flags.getData">
                                <hr class="seperator" />
                                <v-row>
                                  <v-col class="content-col" cols="8">
                                    <h4>{{ $t('esgPlatform.getData') }}</h4>
                                  </v-col>
                                  <v-col cols="4">
                                    <v-row>
                                      <v-col class="content-col" cols="2">{{ $t('esgPlatform.score') }}</v-col>
                                      <v-col cols="3">
                                        <v-text-field
                                          class="bottomless"
                                          v-model="question.getData.getData.score"
                                          outlined
                                          dense
                                        ></v-text-field>
                                      </v-col>
                                      <v-col cols="5">
                                        <v-btn
                                          right
                                          color="primary"
                                          @click="showDatafieldModal(question.getData)"
                                        >
                                          <v-icon
                                            left
                                            dark
                                          >
                                            mdi-database-plus
                                          </v-icon>
                                          {{ $t('esgPlatform.addDataField') }}
                                        </v-btn>
                                      </v-col>
                                      <v-col cols="2">
                                        <v-btn x-small fab color="primary" class="ml-2" @click="openGetDataPreview(question.getData)">
                                          <v-icon>mdi-eye-outline</v-icon>
                                        </v-btn>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>

                                <v-card elevation="0" class="options dark mt-4 mb-5">
                                  <v-card-title>
                                    <v-row>
                                      <v-col class="py-2" cols="4">{{ $t('esgPlatform.dataField') }}</v-col>
                                      <v-col class="py-2" cols="4">{{ $t('esgPlatform.type') }}</v-col>
                                      <v-col class="py-2" cols="3">{{ $t('esgPlatform.mandatory') }}</v-col>
                                      <v-col class="py-2" cols="1"></v-col>
                                    </v-row>
                                  </v-card-title>
                                </v-card>

                                <v-card elevation="0" outlined class="my-4 px-4 py-4" v-for="(field, i) in question.getData.getData.dataFields" v-bind:key="i">
                                  <v-row>
                                    <v-col class="py-2 content-col" cols="4">{{ field.title }}</v-col>
                                    <v-col class="py-2 text-capitalize content-col" cols="4">{{ typeToTitle(field.dataType) }}</v-col>
                                    <v-col class="py-2 content-col" cols="2">
                                      <v-row>
                                        <v-col cols="4">{{ field.isMandatory ? $t('esgPlatform.yes') : $t('esgPlatform.no') }}</v-col>
                                        <v-col cols="8">
                                          <v-switch inset class="bottomless pt-0 mt-0"
                                            v-model="field.isMandatory"
                                          ></v-switch>
                                        </v-col>
                                      </v-row>
                                    </v-col>
                                    <v-col class="py-2 content-col" cols="2">
                                      <v-btn x-small fab color="primary" class="ml-2" @click="editDataField(field, null)">
                                        <v-icon>mdi-pencil</v-icon>
                                      </v-btn>
                                      <v-btn x-small fab color="white" style="color:#000" class="ml-2" @click="removeDataField(field._id, true)">
                                        <v-icon>mdi-delete</v-icon>
                                      </v-btn>
                                    </v-col>
                                  </v-row>
                                </v-card>
                              </section>

                            </v-card-text>
                        </v-card>
                      </v-card>
                    </v-col>

                    <!-- File Attachment Specific fields -->
                    <v-col cols="12" class="px-0" v-if="question.questionType === 'attach-files'">
                      <v-row class="mx-0 px-0">
                        <v-col class="px-0" cols="12">
                          <label>{{ $t('esgPlatform.fileType') }}</label>
                          <v-select
                            :items="fileTypes"
                            item-text="title"
                            item-value="field"
                            v-model="question.allowedFileTypes"
                            dense
                            outlined
                            multiple
                          >
                          </v-select>
                        </v-col>
                        <v-col class="px-0" cols="3">
                          <v-checkbox
                            v-model="question.allowMultipleAttachments"
                            :label="$t('esgPlatform.allowMultipleAttachments')"
                          ></v-checkbox>
                        </v-col>
                        <v-col cols="3" class="px-0">
                          <v-checkbox
                            v-model="question.allowComments"
                            :label="$t('esgPlatform.allowComments')"
                          ></v-checkbox>
                        </v-col>
                        <v-col cols="6"></v-col>
                      </v-row>
                    </v-col>
                    <!-- File Attachment Specific Fields End -->

                    <!-- Digital Signature Specific Fields -->
                    <v-col cols="12" v-if="question.questionType === 'digital-signature'">
                      <v-row>
                        <v-col class="px-0" cols="2">
                          <v-checkbox
                            v-model="question.uploadSignatureFile"
                            :label="$t('esgPlatform.uploadSignatureFile')"
                          ></v-checkbox>
                        </v-col>
                        <v-col class="px-0" cols="2">
                          <v-checkbox
                            v-model="question.drawSignature"
                            :label="$t('esgPlatform.drawSignature')"
                          ></v-checkbox>
                        </v-col>
                        <v-col class="px-0" cols="8"></v-col>
                      </v-row>
                    </v-col>
                  </div>

                  <v-col cols="12" class="px-0">
                      <div class="mb-2">
                        <span class="h3 mr-1">{{ $t('esgPlatform.description') }}</span>
                        <v-tooltip top color="00BD73" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                              <v-icon size="medium" class="icon-with-background" style="color:#0EBF67" v-bind="attrs" v-on="on">
                              mdi-alert-circle
                              </v-icon>
                          </template>
                          <span>{{ $t('esgPlatform.descriptionTooltip') }}</span>
                        </v-tooltip>
                      </div>
                      <v-card outlined class="mb-5">
                        <quill-editor
                          v-model="question.description"
                          ref="quillEditor"
                          :options="quillOptions($t('esgPlatform.enterHere'))"
                        />
                      </v-card>
                    </v-col>

                    <v-col cols="12" class="px-0" v-if="isDimitraModule">
                      <DimitraModule v-model="question.dimitraModule" mode="question"
                        :score-enabled="question.scoreEnabled" :survey-respondent-type="surveyRespondentType"/>
                    </v-col>
                    
                  <div v-if="isOptionType()">
                    <v-row>
                      <v-col cols="12">
                        <div class="mb-2">
                          <span class="h3 mr-1">{{ $t('esgPlatform.question') }}</span>
                          <v-tooltip top color="00BD73" max-width="350">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon size="medium" class="icon-with-background" style="color:#0EBF67" v-bind="attrs" v-on="on">
                                mdi-alert-circle
                                </v-icon>
                            </template>
                            <span>{{ $t('esgPlatform.titleTooltip') }}</span>
                          </v-tooltip>
                        </div>
                        <v-text-field
                          v-model="question.title"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <div class="mb-2">
                          <span class="h3 mr-1">{{ $t('esgPlatform.addOption') }}</span>
                          <v-tooltip top color="00BD73" max-width="350">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon size="medium" class="icon-with-background" style="color:#0EBF67" v-bind="attrs" v-on="on">
                                mdi-alert-circle
                                </v-icon>
                            </template>
                            <span>{{ $t('esgPlatform.addOptionTooltip') }}</span>
                          </v-tooltip>
                        </div>
                        <v-row>
                          <v-col class="pb-0" cols="8">
                            <v-text-field
                              class="bottomless"
                              v-model="newOption"
                              @keyup.enter="addOption"
                              outlined
                              dense
                            ></v-text-field>
                          </v-col>
                          <v-col class="pb-0" cols="4">
                            <v-btn
                              right
                              color="primary"
                              @click="addOption"
                            >
                              {{ $t('esgPlatform.add') }}
                            </v-btn>
                          </v-col>
                          <v-col class="pt-0" cols="12">
                            <small class="text--disabled">{{ $t('esgPlatform.pressEnterToAdd') }}</small>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>

                    <!-- Options section -->
                    <v-card elevation="0" class="options mb-5">
                      <v-card-title>
                        <v-row>
                          <v-col class="py-2" cols="8">{{ $t('esgPlatform.options') }}</v-col>
                          <v-col class="py-2" cols="4">{{ $t('esgPlatform.actions') }}</v-col>
                        </v-row>
                      </v-card-title>
                    </v-card>

                    <v-card elevation="0" class="option mb-5" v-for="(option, i) in question.options" v-bind:key="i">
                      <v-row>
                        <v-col cols="8">
                          <v-row>
                            <v-col cols="1">
                              <v-col class="py-0">
                                <div>
                                  <v-icon>mdi-chevron-up</v-icon>
                                </div>
                              </v-col>
                              <v-col class="py-0">
                                <div>
                                  <v-icon>mdi-chevron-down</v-icon>
                                </div>
                              </v-col>
                            </v-col>
                            <v-col class="py-4" cols="11">
                              <div class="content-col right-border-col w-100">
                                {{ option.title }}
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="4">
                          <v-row>
                            <v-col cols="4">
                              <v-row>
                                <v-col class="content-col" cols="5">{{ $t('esgPlatform.score') }}</v-col>
                                <v-col cols="7">
                                  <v-text-field
                                    class="bottomless"
                                    v-model="option.score"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col class="content-col pl-5 pr-0" cols="4">
                              <v-row class="clickable" @click="expandOption(option)">
                                <v-col cols="8" class="px-0 py-0">{{ getActionName(option) }}</v-col>
                                <v-col cols="4" class="px-0 py-0"><v-icon color="primary">{{ getActionChevron(option) }}</v-icon></v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12" v-if="option.expanded">
                          <v-card elevation="0" class="expandable mx-4">
                            <v-card-text>
                              <v-row>
                                <v-col cols="9">
                                  <h3>{{ $t('esgPlatform.actions') }}</h3>
                                  <v-row>
                                    <v-col
                                      v-for="action in availableOptionActions"
                                      :key="action.flagKey"
                                    >
                                      <v-checkbox
                                        v-model="option.flags[action.flagKey]"
                                        :label="action.label"
                                      ></v-checkbox>
                                    </v-col>
                                    <v-col></v-col>
                                  </v-row>
                                </v-col>
                                <v-col class="content-col" cols="3">
                                  <v-row>
                                    <v-col cols="5" class="content-col"><h3>{{ $t('esgPlatform.condition') }}</h3></v-col>
                                    <v-col cols="7">
                                      <v-select
                                        :items="conditions"
                                        v-model="option.condition"
                                        dense
                                        outlined
                                        clearable
                                        @change="handleConditionChange(option)"
                                      >
                                      </v-select>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                              <section v-if="isOptionActionEnabled(option, 'recommendations')">
                                <hr class="seperator" />
                                <h4 class="mb-4">{{ $t('esgPlatform.recommendations') }}</h4>
                                <v-textarea
                                  class="text--small"
                                  v-model="option.recommendations"
                                  rows="5"
                                  :placeholder="$t('esgPlatform.enterYourRecommendations')"
                                  outlined
                                ></v-textarea>
                              </section>
                              <section v-if="isOptionActionEnabled(option, 'getData')">
                                <hr class="seperator" />
                                <v-row>
                                  <v-col class="content-col" cols="8">
                                    <h4>{{ $t('esgPlatform.getData') }}</h4>
                                  </v-col>
                                  <v-col cols="4">
                                    <v-row>
                                      <v-col class="content-col" cols="2">{{ $t('esgPlatform.score') }}</v-col>
                                      <v-col cols="3">
                                        <v-text-field
                                          class="bottomless"
                                          v-model="option.getData.score"
                                          outlined
                                          dense
                                        ></v-text-field>
                                      </v-col>
                                      <v-col cols="5">
                                        <v-btn
                                          right
                                          color="primary"
                                          @click="showDatafieldModal(option)"
                                        >
                                          <v-icon
                                            left
                                            dark
                                          >
                                            mdi-database-plus
                                          </v-icon>
                                          {{ $t('esgPlatform.addDataField') }}
                                        </v-btn>
                                      </v-col>
                                      <v-col cols="2">
                                        <v-btn x-small fab color="primary" class="ml-2" @click="openGetDataPreview(option)">
                                          <v-icon>mdi-eye-outline</v-icon>
                                        </v-btn>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>

                                <v-card elevation="0" class="options dark mt-4 mb-5">
                                  <v-card-title>
                                    <v-row>
                                      <v-col class="py-2" cols="4">{{ $t('esgPlatform.dataField') }}</v-col>
                                      <v-col class="py-2" cols="4">{{ $t('esgPlatform.type') }}</v-col>
                                      <v-col class="py-2" cols="3">{{ $t('esgPlatform.mandatory') }}</v-col>
                                      <v-col class="py-2" cols="1"></v-col>
                                    </v-row>
                                  </v-card-title>
                                </v-card>

                                <v-card elevation="0" outlined class="my-4 px-4 py-4" v-for="(field, i) in option.getData.dataFields" v-bind:key="i">
                                  <v-row>
                                    <v-col class="py-2 content-col" cols="4">{{ field.title }}</v-col>
                                    <v-col class="py-2 text-capitalize content-col" cols="4">{{ typeToTitle(field.dataType) }}</v-col>
                                    <v-col class="py-2 content-col" cols="2">
                                      <v-row>
                                        <v-col cols="4">{{ field.isMandatory ? $t('esgPlatform.yes') : $t('esgPlatform.no') }}</v-col>
                                        <v-col cols="8">
                                          <v-switch inset class="bottomless pt-0 mt-0"
                                            v-model="field.isMandatory"
                                          ></v-switch>
                                        </v-col>
                                      </v-row>
                                    </v-col>
                                    <v-col class="py-2 content-col" cols="2">
                                      <v-btn x-small fab color="primary" class="ml-2" @click="editDataField(field, option._id)">
                                        <v-icon>mdi-pencil</v-icon>
                                      </v-btn>
                                      <v-btn x-small fab color="white" style="color:#000" class="ml-2" @click="removeDataField(field._id)">
                                        <v-icon>mdi-delete</v-icon>
                                      </v-btn>
                                    </v-col>
                                  </v-row>
                                </v-card>
                              </section>

                              <section v-if="isOptionActionEnabled(option, 'actionPlan')">
                                <hr class="seperator" />
                                <v-row>
                                  <v-col class="content-col" cols="10">
                                    <h4>{{ $t('esgPlatform.actionPlan') }}</h4>
                                  </v-col>
                                  <v-col cols="2">
                                    <v-row>
                                      <v-col class="content-col">{{ $t('esgPlatform.score') }}</v-col>
                                      <v-col>
                                        <v-text-field
                                          class="bottomless"
                                          v-model="option.actionPlan.score"
                                          outlined
                                          dense
                                        ></v-text-field>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>

                                <v-card elevation="0" class="gray lighten-4 my-4 px-4 py-4" v-for="(item, ii) in option.actionPlan.items" v-bind:key="ii">
                                  <v-row>
                                    <v-col class="content-col right-border-col py-0 my-3" cols="9">{{ item.item }}</v-col>
                                    <v-col class="text-capitalize content-col py-0 my-3" cols="3">
                                      <v-checkbox
                                        v-model="item.requireFile"
                                        :label="$t('esgPlatform.requireFileAttachment')"
                                        @change="updateActionPlan(option, item)"
                                      ></v-checkbox>
                                    </v-col>
                                  </v-row>
                                </v-card>

                                <v-row class="mb-4">
                                  <v-col class="pb-0" cols="8">
                                    <v-text-field
                                      class="bottomless"
                                      v-model="newActionPlan"
                                      @keyup.enter="addAction(option)"
                                      outlined
                                      dense
                                    ></v-text-field>
                                  </v-col>
                                  <v-col class="pb-0" cols="4">
                                    <v-btn
                                      right
                                      color="primary"
                                      @click="addAction(option)"
                                    >
                                      {{ $t('esgPlatform.add') }}
                                    </v-btn>
                                  </v-col>
                                </v-row>
                              </section>

                              <section v-if="isOptionActionEnabled(option, 'dimitraModules')">
                                <hr class="seperator" />
                                <DimitraModule v-model="option.dimitraModule" mode="option"
                                  :survey-respondent-type="surveyRespondentType"/>
                              </section>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-card>
                    <!-- Option Section End -->
                  </div>

                  <section v-if="isRepeatFeatureEnabled" class="repeat pt-5">
                    <v-row>
                      <v-col cols="4">
                        <div class="mb-2">
                          <span class="h3 mr-1">{{ $t('esgPlatform.repeatPeriodically') }}</span>
                          <v-tooltip top color="00BD73" max-width="350">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon size="medium" class="icon-with-background" style="color:#0EBF67" v-bind="attrs" v-on="on">
                                mdi-alert-circle
                                </v-icon>
                            </template>
                            <span>{{ $t('esgPlatform.repeatPeriodicallyTooltip') }}</span>
                          </v-tooltip>
                        </div>
                      </v-col>
                      <v-col cols="2">
                        <v-row>
                          <v-col>{{ question.repeat.enabled ? $t('esgPlatform.enabled') : $t('esgPlatform.disabled') }}</v-col>
                          <v-col>
                            <v-switch inset class="bottomless pt-0 mt-0"
                              v-model="question.repeat.enabled"
                              :disabled="isQuestionRepeatLocked"
                            ></v-switch>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>

                    <v-radio-group
                      v-model="question.repeat.type"
                      @change="clearSelectedDates"
                      row
                    >
                      <v-radio
                        v-for="(type, it) in repeatTypes"
                        :key="it"
                        :label="type.label"
                        :value="type.value"
                      ></v-radio>
                    </v-radio-group>

                    <div v-if="question.repeat.type === 'Custom'">
                      <v-dialog
                        ref="cdialog"
                        v-model="dateModalCustom"
                        :return-value.sync="selectedCustomDate"
                        persistent
                        width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            class="answerer-select"
                            v-model="selectedCustomDate"
                            :label="$t('esgPlatform.selectDate')"
                            prepend-inner-icon="mdi-calendar"
                            outlined
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="selectedCustomDate"
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="dateModalCustom = false"
                          >
                            {{ $t('esgPlatform.cancel') }}
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="saveCustomDate(selectedCustomDate)"
                          >
                            {{ $t('esgPlatform.ok') }}
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>

                      <v-card elevation="0" width="450px" class="gray lighten-4 my-4 px-4 py-4">
                        <div class="mb-2">
                          <span class="h4 mr-1">{{ $t('esgPlatform.repetitionDates') }}</span>
                          <v-tooltip top color="00BD73" max-width="350">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon size="medium" class="icon-with-background" style="color:#0EBF67" v-bind="attrs" v-on="on">
                                mdi-alert-circle
                                </v-icon>
                            </template>
                            <span>{{ $t('esgPlatform.repetitionDatesTooltip') }}</span>
                          </v-tooltip>
                        </div>
                        
                        <v-row class="mt-0" v-for="(date, id) in question.repeat.selectedDates" :key="id">
                          <v-col class="content-col" cols="10">
                            {{ date }}
                          </v-col>
                          <v-col cols="2">
                            <v-btn class="mx-1" fab x-small color="black"
                              @click="deleteCustomDate(id)">
                              <v-icon color="white"> mdi-close </v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card>
                    </div>
                    <div v-if="question.repeat.type === 'Fixed'">
                      <v-row>
                        <v-col class="content-col" cols="2">{{ $t('esgPlatform.repeatsEvery') }}</v-col>
                        <v-col cols="3">
                          <v-select
                            :items="fixedRepeatTypes"
                            v-model="question.repeat.fixedRepeatType"
                            dense
                            outlined
                            clearable
                          >
                          </v-select>
                        </v-col>
                      </v-row>
                      <v-row class="mb-4">
                        <v-col class="content-col" cols="2">{{ $t('esgPlatform.repetitions') }}</v-col>
                        <v-col cols="3">
                          <v-text-field
                            type="number"
                            v-model="question.repeat.fixedRepetitions"
                            outlined
                            dense
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>

                      <label for="fdialog">{{ $t('esgPlatform.selectStartDate') }}</label>
                      <v-dialog
                        ref="fdialog"
                        v-model="dateModalFixed"
                        :return-value.sync="selectedStartDate"
                        persistent
                        width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            class="answerer-select mt-2"
                            v-model="selectedStartDate"
                            :label="$t('esgPlatform.selectDate')"
                            prepend-inner-icon="mdi-calendar"
                            outlined
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="selectedStartDate"
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="dateModalFixed = false"
                          >
                            {{ $t('esgPlatform.cancel') }}
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="saveStartDate(selectedStartDate)"
                          >
                            {{ $t('esgPlatform.ok') }}
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>
                      <v-card elevation="0" width="450px" class="gray lighten-4 my-4 px-4 py-4">
                        <div class="mb-2">
                          <span class="h4 mr-1">{{ $t('esgPlatform.repetitionDates') }}</span>
                          <v-tooltip top color="00BD73" max-width="350">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon size="medium" class="icon-with-background" style="color:#0EBF67" v-bind="attrs" v-on="on">
                                mdi-alert-circle
                                </v-icon>
                            </template>
                            <span>{{ $t('esgPlatform.repetitionDatesTooltip') }}</span>
                          </v-tooltip>
                        </div>
                        
                        <v-row class="mt-0" v-for="(date, id) in question.repeat. selectedDates" :key="id">
                          <v-col class="content-col" cols="12">
                            {{ date }}
                          </v-col>
                        </v-row>
                      </v-card>
                    </div>
                  </section>

                  </fieldset>
                  <!-- End Buttons -->
                  <section class="question-footer">
                    <v-btn
                      right
                      outlined
                      color="primary"
                      @click="closeModal"
                    >
                      {{ viewOnly ? $t('esgPlatform.close') : $t('esgPlatform.cancel') }}
                    </v-btn>
                    <v-btn
                      v-if="!viewOnly"
                      right
                      color="primary"
                      @click="openPreview"
                    >
                      {{ $t('esgPlatform.preview') }}
                    </v-btn>
                    <v-btn
                      v-if="!viewOnly"
                      right
                      color="primary"
                      @click="saveQuestion"
                    >
                      {{ $t('esgPlatform.submit') }}
                    </v-btn>
                  </section>
                </v-card-text>
              </v-form>
            </v-card>
          </v-dialog>
        </div>
      </template>
    </v-container>
    <DataField 
      @closeDialog="datafieldModal = false"
      @addDatafield="addDataField"
      :dialogI="datafieldModal" 
      :isEdit="dataFieldEdit"
      :selectedDataField="selectedDataField"
      :isAssessmentEditMode="isAssessmentEditMode"
    />
    <Preview :questions="previewQuestions"
      :dialogI="showPreview"
      :isGetData="isGetDataPreview"
      @closeModal="closePreview" />
  </div>
</template>
<script>
import loadingMixin from "@/mixins/LoadingMixin";
import DataField from "./components/DataField.vue";
import EsgService from "../../../_services/EsgService";
import Preview from "./components/Preview.vue";
import DimitraModule from "./components/DimitraModule.vue";
import { getDimitraAppForRespondentType } from "./constants/esgDimitraModule";
import { quillEditor } from 'vue-quill-editor';
import {
  DEFAULT_SURVEY_BUILDER_CONFIG,
  FARMER_QUESTION_RESPONDENT_TYPES,
  SURVEY_POST_ANSWER_ACTIONS,
  getQuestionRespondentTypeOptionsForSurvey,
  isQuestionRespondentTypeAllowedForSurvey,
  normalizeQuestionRespondentTypeForSurvey,
  normalizePostAnswerActionsForAudience,
  normalizeQuestionTypesForAudience,
  normalizeSurveyBuilderConfig,
} from "./constants/surveyBuilderConfig";

const DEFAULT_QUESTION_ANSWERER = "Farmer (Single response for all farms)";
const ALL_QUESTION_TYPES = "all";
const OPTION_ACTION_TRANSLATION_KEYS = Object.freeze({
  recommendations: "esgPlatform.recommendations",
  getData: "esgPlatform.getData",
  actionPlan: "esgPlatform.actionPlan",
  dimitraModules: "esgPlatform.dimitraModules",
});
const OPTION_ACTIONS = Object.freeze(Object.values(SURVEY_POST_ANSWER_ACTIONS));

const LOCKED_PARENT_QUESTION_FIELDS = Object.freeze({
  scoreEnabled: {
    questionPath: ["scoreEnabled"],
    parentKeys: ["isScoreEnabled"],
    normalize: (value) => Boolean(value),
  },
  answerer: {
    questionPath: ["answerer"],
    parentKeys: [],
    normalize: (value) => value || DEFAULT_QUESTION_ANSWERER,
  },
  repeatEnabled: {
    questionPath: ["repeat", "enabled"],
    parentKeys: ["isRepeatQuestionEnabled"],
    normalize: (value) => Boolean(value),
  },
});

const hasOwn = (object, key) => Object.prototype.hasOwnProperty.call(object || {}, key);

const hasParentValue = (value) => value !== undefined && value !== null && value !== "";

const getQuestionFieldPath = (fieldConfig = {}) => {
  if (Array.isArray(fieldConfig.questionPath)) {
    return fieldConfig.questionPath;
  }

  return String(fieldConfig.questionKey || "").split(".").filter(Boolean);
};

export default {
  components: {
    DataField,
    Preview,
    DimitraModule,
    'quill-editor': quillEditor
  },
  props: {
    isEdit: {
      type: Boolean,
      required: true,
      default: false,
    },
    // View-only mode: open the same screen to inspect a question (e.g. a
    // read-only survey owned by someone else) with all inputs disabled and the
    // Preview / Submit actions hidden.
    viewOnly: {
      type: Boolean,
      default: false,
    },
    dialogI: {
      type: Boolean,
      required: true,
    },
    selectedQuestion: {
      type: String,
      required: false,
    },
    selectedHeading: {
      type: String,
      required: false,
    },
    selectedSurvey: {
      type: Object,
      required: false,
    },
    assessmentRespondentType: {
      type: String,
      required: false,
    },
    surveyId: {
      type: String,
      required: false,
    },
    headings: {
      type: Array,
      required: true,
    },
    assessment: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      question: {
        _id: null,
        esgAssessmentId: null,
        esgHeadingId: null,
        order: null,
        createdBy: null,
        orgId: null,
        title: "",
        scoreEnabled: false,
        score: null,
        isMandatory: false,
        answerer: DEFAULT_QUESTION_ANSWERER,
        heading: "Water Scarcity",
        questionType: "text-field",
        allowedFileTypes: [],
        allowMultipleAttachments: false,
        allowComments: false,
        uploadSignatureFile: false,
        drawSignature: false,
        description: "",
        dimitraModule: {},
        getData: {
          condition: "Any",
          getData: {
            score: 0,
            expanded: false,
            dataFields: [],
          },
          flags: {
            getData: false,
          },
        },
        options: [],
        repeat: {
          enabled: false,
          type: "Fixed",
          selectedDates: [],
          fixedStartDate: null,
          fixedRepeatType: null,
          fixedRepetitions: 0,
        },
      },
      showPreview: false,
      surveyBuilderConfig: DEFAULT_SURVEY_BUILDER_CONFIG,
      parentSurveySnapshot: null,
      isGetDataPreview: false,
      previewQuestions: [],
      newOption: null,
      newActionPlan: null,
      dateModalCustom: false,
      selectedCustomDate: null,
      dateModalFixed: false,
      selectedStartDate: null,
      datafieldModal: false,
      dataFieldEdit: false,
      datafieldSource: null,
      selectedDataField: {},
      isAssessmentEditMode: this.isEdit,
      fileTypes: [
        {
          field: "image",
          title: this.$t('esgPlatform.fileTypeImage')
        },
        {
          field: "video",
          title: this.$t('esgPlatform.fileTypeVideo')
        },
        {
          field: "docx",
          title: this.$t('esgPlatform.fileTypeDocx')
        },
        {
          field: "pdf",
          title: this.$t('esgPlatform.fileTypePdf')
        }
      ],
      answerers: [],
      dimitraAnswerers: FARMER_QUESTION_RESPONDENT_TYPES,
      dimitraModuleQuestionType: {
        value: "dimitra-module",
        label: this.$t('esgPlatform.validation.dimitraModule'),
      },
       questionTypes: [
        { value: "text-field", label: this.$t('esgPlatform.textField') },
        { value: "text-area", label: this.$t('esgPlatform.textArea') },
        { value: "numeric", label: this.$t('esgPlatform.textFieldNumeric') },
        { value: "radio-button", label: this.$t('esgPlatform.radioButton') },
        { value: "check-boxes", label: this.$t('esgPlatform.checkBoxes') },
        { value: "get-data", label: this.$t('esgPlatform.getDataLabel') },
        { value: "attach-files", label: this.$t('esgPlatform.attachFiles') },
        { value: "digital-signature", label: this.$t('esgPlatform.digitalSignature') },
      ],
      conditions: [
        "All",
        "Any"
      ],
      repeatTypes: [
        {
          label: this.$t('esgPlatform.fixedFrequency'),
          value: "Fixed"
        },
        {
          label: this.$t('esgPlatform.custom'),
          value: "Custom"
        }
      ],
      fixedRepeatTypes: [
        this.$t('esgPlatform.day'),
        this.$t('esgPlatform.week'),
        this.$t('esgPlatform.month'),
        this.$t('esgPlatform.quarter'),
        this.$t('esgPlatform.year'),
      ]
    };
  },
  computed: {
    answererOptions() {
      return getQuestionRespondentTypeOptionsForSurvey(
        this.getQuestionAudienceContext(),
        this.surveyBuilderConfig
      );
    },
    isQuestionScoreLocked() {
      return this.hasLockedParentQuestionValue("scoreEnabled");
    },
    isQuestionAnswererLocked() {
      return this.answererOptions.length <= 1;
    },
    isQuestionRepeatLocked() {
      return this.hasLockedParentQuestionValue("repeatEnabled");
    },
    hasQuestionLevelScore() {
      return this.question.scoreEnabled && !['radio-button', 'check-boxes', 'get-data'].includes(this.question.questionType); 
    },
    dialog() {
      return this.dialogI;
    },
    getOrganizationId() {
      return this.$store.getters.getUser?.user_organization?.id;
    },
    getUserId() {
      return this.$store.getters.getUser?.id;
    },
    isDimitraAnswerer() {
      return this.dimitraAnswerers.includes(this.question.answerer);
    },
    isRepeatFeatureEnabled() {
      if (this.hasLockedParentQuestionValue("repeatEnabled")) {
        return Boolean(this.getLockedParentQuestionValue("repeatEnabled"));
      }

      return !!this.assessment?.isRepeatQuestionEnabled;
    },
    availableOptionActions() {
      const parentActions = this.getParentPostAnswerActions();

      return OPTION_ACTIONS
        .filter(({ value, flagKey }) => (
          parentActions.includes(value)
          && (flagKey !== "dimitraModules" || this.isDimitraAnswerer)
        ))
        .map((action) => ({
          ...action,
          label: this.$t(OPTION_ACTION_TRANSLATION_KEYS[action.flagKey]) || action.label,
        }));
    },
    availableOptionActionFlags() {
      return this.availableOptionActions.map(({ flagKey }) => flagKey);
    },
    questionTypeOptions() {
      const allowedQuestionTypes = this.getParentAllowedQuestionTypes();
      const shouldFilterQuestionTypes = Array.isArray(allowedQuestionTypes)
        && allowedQuestionTypes.length
        && !allowedQuestionTypes.includes(ALL_QUESTION_TYPES);
      const options = shouldFilterQuestionTypes
        ? this.questionTypes.filter((item) => allowedQuestionTypes.includes(item.value))
        : [...this.questionTypes];
      if (this.isDimitraAnswerer) {
        if (!shouldFilterQuestionTypes || allowedQuestionTypes.includes(this.dimitraModuleQuestionType.value)) {
          options.push(this.dimitraModuleQuestionType);
        }
      }
      return options;
    },
    isDimitraModule() {
      return this.question.questionType === this.dimitraModuleQuestionType.value;
    },
    surveyRespondentType() {
      return this.assessmentRespondentType || this.selectedSurvey?.respondentType || null;
    },
  },
  watch: {
    assessment: {
      handler() {
        this.applyParentLockedQuestionFields();
        this.sanitizeQuestionConfiguration();
      },
      deep: false,
    },
    selectedSurvey: {
      handler() {
        this.applyParentLockedQuestionFields();
        this.sanitizeQuestionConfiguration();
      },
      deep: false,
    },
    "question.scoreEnabled"(newVal) {
      if (!this.isLockedQuestionFieldValue("scoreEnabled", newVal)) {
        this.applyParentLockedQuestionField("scoreEnabled");
      }
    },
    "question.repeat.enabled"(newVal) {
      if (!this.isLockedQuestionFieldValue("repeatEnabled", newVal)) {
        this.applyParentLockedQuestionField("repeatEnabled");
      }
    },
    "question.answerer"(newVal) {
      if (!this.isLockedQuestionFieldValue("answerer", newVal)) {
        this.applyParentLockedQuestionField("answerer");
        return;
      }

      if (!this.dimitraAnswerers.includes(newVal) && this.question.questionType === this.dimitraModuleQuestionType.value) {
        this.question.questionType = this.questionTypes[0]?.value || null;
        this.question.dimitraModule = {};
      }

      this.sanitizeQuestionConfiguration();
    },
    questionTypeOptions(newOptions) {
      if (!newOptions.some((option) => option.value === this.question.questionType)) {
        this.question.questionType = newOptions[0]?.value || null;
        this.question.dimitraModule = {};
      }
    },
    availableOptionActionFlags() {
      this.sanitizeAllOptionActions();
    },
  },
  async created() {
    await this.loadSurveyBuilderConfig();
    await this.loadParentSurveySnapshotIfNeeded();
    this.applyParentLockedQuestionFields();

    // If editing an existing question, fetch and populate data
    if (this.isEdit && this.selectedQuestion) {
      await this.fetchQuestionDetails(this.selectedQuestion);
      this.applyParentLockedQuestionFields();
      this.sanitizeQuestionConfiguration();
    }

    if (this.selectedHeading) {
      this.question.esgHeadingId = this.selectedHeading;
    }

    this.sanitizeQuestionConfiguration();
  },
  mounted() {},
  methods: {
    async loadSurveyBuilderConfig() {
      try {
        const response = await EsgService.getAssessmentSurveyBuilderConfig();
        const config = response?.data;

        if (config?.audienceTypeConfig) {
          this.surveyBuilderConfig = normalizeSurveyBuilderConfig(config);
        }
      } catch (error) {
        console.warn("Using local survey builder configuration fallback", error);
      }
    },
    getParentSurveySources() {
      return [this.assessment, this.selectedSurvey, this.parentSurveySnapshot]
        .filter((source) => source && typeof source === "object");
    },
    getParentSurveyConfigValue(parentKeys = [], fallbackValue = undefined) {
      for (const source of this.getParentSurveySources()) {
        for (const parentKey of parentKeys) {
          if (hasOwn(source, parentKey) && hasParentValue(source[parentKey])) {
            return source[parentKey];
          }
        }
      }

      return fallbackValue;
    },
    getParentAttachedModule() {
      return this.getParentSurveyConfigValue(["attachedModule"], null);
    },
    getParentSurveyRespondentType() {
      return this.getParentSurveyConfigValue(["respondentType"], null);
    },
    getQuestionAudienceContext() {
      return {
        attachedModule: this.getParentAttachedModule(),
        respondentType: this.getParentSurveyRespondentType(),
      };
    },
    getParentRespondentType() {
      return this.getParentSurveyRespondentType()
        || this.question.answerer
        || DEFAULT_QUESTION_ANSWERER;
    },
    getParentPostAnswerActions() {
      const parentActions = this.getParentSurveyConfigValue(["postAnswerActions"]);
      return normalizePostAnswerActionsForAudience(
        Array.isArray(parentActions) ? parentActions : [],
        this.getParentRespondentType(),
        this.surveyBuilderConfig
      );
    },
    getParentAllowedQuestionTypes() {
      const parentQuestionTypes = this.getParentSurveyConfigValue(["allowedQuestionTypes"]);
      return normalizeQuestionTypesForAudience(
        Array.isArray(parentQuestionTypes) ? parentQuestionTypes : [ALL_QUESTION_TYPES],
        this.getParentRespondentType(),
        this.surveyBuilderConfig
      );
    },
    getAllOptionActionFlags() {
      return OPTION_ACTIONS.map(({ flagKey }) => flagKey);
    },
    isOptionActionAvailable(flagKey) {
      return this.availableOptionActionFlags.includes(flagKey);
    },
    getSanitizedOptionActionFlags(option = {}) {
      const flags = {
        recommendations: false,
        getData: false,
        actionPlan: false,
        dimitraModules: false,
        ...(option.flags || {}),
      };

      this.getAllOptionActionFlags().forEach((flagKey) => {
        flags[flagKey] = Boolean(flags[flagKey] && this.isOptionActionAvailable(flagKey));
      });

      return flags;
    },
    sanitizeOptionActions(option) {
      if (!option || typeof option !== "object") {
        return {
          recommendations: false,
          getData: false,
          actionPlan: false,
          dimitraModules: false,
        };
      }

      const flags = this.getSanitizedOptionActionFlags(option);
      this.$set(option, "flags", flags);

      if (!flags.dimitraModules) {
        this.$set(option, "dimitraModule", {});
      }

      return flags;
    },
    sanitizeAllOptionActions() {
      (this.question.options || []).forEach((option) => {
        this.sanitizeOptionActions(option);
      });
    },
    sanitizeQuestionAnswerer() {
      const normalizedAnswerer = normalizeQuestionRespondentTypeForSurvey(
        this.getQuestionAudienceContext(),
        this.question.answerer,
        this.surveyBuilderConfig
      );

      if (normalizedAnswerer && normalizedAnswerer !== this.question.answerer) {
        this.question.answerer = normalizedAnswerer;
      }

      return normalizedAnswerer;
    },
    sanitizeQuestionConfiguration() {
      this.sanitizeQuestionAnswerer();

      if (!this.questionTypeOptions.some((option) => option.value === this.question.questionType)) {
        this.question.questionType = this.questionTypeOptions[0]?.value || null;
        this.question.dimitraModule = {};
      }

      this.sanitizeAllOptionActions();
    },
    validateQuestionAudience() {
      const answerer = this.sanitizeQuestionAnswerer();

      if (
        !answerer
        || !isQuestionRespondentTypeAllowedForSurvey(
          this.getQuestionAudienceContext(),
          answerer,
          this.surveyBuilderConfig
        )
      ) {
        this.$notify({
          title: this.surveyBuilderConfig.validationMessages.questionRespondentTypeInvalid,
          type: "error",
        });
        return false;
      }

      return true;
    },
    isOptionActionEnabled(option, flagKey) {
      return Boolean(this.isOptionActionAvailable(flagKey) && option?.flags?.[flagKey]);
    },
    getLockedFieldConfig(fieldName) {
      return LOCKED_PARENT_QUESTION_FIELDS[fieldName] || null;
    },
    getQuestionValueByPath(path = []) {
      return path.reduce((value, key) => (
        value && typeof value === "object" ? value[key] : undefined
      ), this.question);
    },
    setQuestionValueByPath(path = [], value) {
      if (!path.length) return;

      const finalKey = path[path.length - 1];
      const target = path.slice(0, -1).reduce((object, key) => {
        if (!object[key] || typeof object[key] !== "object") {
          this.$set(object, key, {});
        }
        return object[key];
      }, this.question);

      this.$set(target, finalKey, value);
    },
    getRawParentQuestionValue(fieldName) {
      const fieldConfig = this.getLockedFieldConfig(fieldName);
      if (!fieldConfig) return undefined;

      for (const source of this.getParentSurveySources()) {
        for (const parentKey of fieldConfig.parentKeys) {
          if (hasOwn(source, parentKey) && hasParentValue(source[parentKey])) {
            return source[parentKey];
          }
        }
      }

      return undefined;
    },
    hasLockedParentQuestionValue(fieldName) {
      return hasParentValue(this.getRawParentQuestionValue(fieldName));
    },
    getLockedParentQuestionValue(fieldName) {
      const fieldConfig = this.getLockedFieldConfig(fieldName);
      const rawValue = this.getRawParentQuestionValue(fieldName);

      if (!fieldConfig || !hasParentValue(rawValue)) {
        return undefined;
      }

      return fieldConfig.normalize ? fieldConfig.normalize(rawValue) : rawValue;
    },
    getQuestionFieldValueForPayload(fieldName) {
      const fieldConfig = this.getLockedFieldConfig(fieldName);
      if (!fieldConfig) return undefined;
      const questionPath = getQuestionFieldPath(fieldConfig);

      const parentValue = this.getLockedParentQuestionValue(fieldName);
      if (hasParentValue(parentValue)) {
        this.setQuestionValueByPath(questionPath, parentValue);
        return parentValue;
      }

      return this.getQuestionValueByPath(questionPath);
    },
    isLockedQuestionFieldValue(fieldName, value) {
      if (!this.hasLockedParentQuestionValue(fieldName)) {
        return true;
      }

      return value === this.getLockedParentQuestionValue(fieldName);
    },
    applyParentLockedQuestionField(fieldName) {
      const fieldConfig = this.getLockedFieldConfig(fieldName);
      const parentValue = this.getLockedParentQuestionValue(fieldName);

      if (!fieldConfig || !hasParentValue(parentValue)) {
        return;
      }

      this.setQuestionValueByPath(getQuestionFieldPath(fieldConfig), parentValue);
    },
    applyParentLockedQuestionFields() {
      Object.keys(LOCKED_PARENT_QUESTION_FIELDS).forEach((fieldName) => {
        this.applyParentLockedQuestionField(fieldName);
      });
    },
    hasAllLockedParentQuestionValues() {
      return Object.keys(LOCKED_PARENT_QUESTION_FIELDS)
        .every((fieldName) => this.hasLockedParentQuestionValue(fieldName));
    },
    hasParentSurveyQuestionConfigValues() {
      return hasParentValue(this.getParentSurveyConfigValue(["postAnswerActions"]))
        && hasParentValue(this.getParentSurveyConfigValue(["allowedQuestionTypes"]))
        && hasParentValue(this.getParentAttachedModule())
        && hasParentValue(this.getParentSurveyRespondentType());
    },
    async loadParentSurveySnapshotIfNeeded() {
      if (
        (this.hasAllLockedParentQuestionValues() && this.hasParentSurveyQuestionConfigValues())
        || !this.surveyId
      ) {
        return;
      }

      try {
        const response = await EsgService.getAssessmentById(this.surveyId);
        if (response?.success && response.data) {
          this.parentSurveySnapshot = response.data;
        }
      } catch (error) {
        console.warn("Unable to load parent survey lock values", error);
      }
    },
    quillOptions(placeholder) {
      return {
        theme: 'snow',
        placeholder,
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ header: [1, 2, 3, false] }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ color: [] }, { background: [] }],
            ['clean']
          ]
        }
      }
    },
    handleConditionChange(option) {
      const enabled = option.condition === "All";
      const flags = this.sanitizeOptionActions(option);

      this.getAllOptionActionFlags().forEach((flagKey) => {
        this.$set(flags, flagKey, enabled && this.isOptionActionAvailable(flagKey));
      });

      this.$set(option, "flags", flags);

      if (option.condition === "All") {
        return;
      }

      this.sanitizeOptionActions(option);
    },
    transformGetData(dataField) {
      return {
        dataType: dataField.dataType,
        title: dataField.title,
        isMandatory: dataField.isMandatory,
        optionValues: dataField.optionValues || [],
        helpText: dataField.helpText || "",
        helpEnabled: dataField.helpEnabled || false,
        _id: dataField._id,
        additionalSettings: dataField.additionalSettings,
        orgId: dataField.orgId,
        createdBy: dataField.createdBy,
      };
    },
    async fetchQuestionDetails(questionId) {
      try {
        const response = await EsgService.getAssessmentQuestionById(questionId);
        if (!response.success) {
          this.$notify({
            title: this.$t('esgPlatform.error'),
            text: response.message || this.$t('esgPlatform.unableToFetchAssessmentQuestion'),
            type: "error",
          });
          return;
        }

          const fetchedQuestion = response.data.question;
          const fetchedOptions = response.data.options || [];
        const dimitraModule = Array.isArray(fetchedQuestion.dimitraModules) && fetchedQuestion.dimitraModules.length > 0
          ? fetchedQuestion.dimitraModules[0] : (fetchedQuestion.dimitraModule || {});

          this.question = {
            _id: fetchedQuestion._id,
            esgHeadingId: fetchedQuestion.esgHeadingId,
            title: fetchedQuestion.title,
            scoreEnabled: fetchedQuestion.isScoreEnabled || false,
            score: (fetchedQuestion.isScoreEnabled && !['radio-button', 'check-boxes', 'get-data'].includes(fetchedQuestion.questionType)) ? fetchedQuestion.score : null, 
            isMandatory: fetchedQuestion.isMandatory || false,
            answerer: fetchedQuestion.respondentType || "",
            questionType: fetchedQuestion.questionType,
            allowedFileTypes: fetchedQuestion.additionalSetting?.allowedFileTypes || [],
            allowMultipleAttachments: fetchedQuestion.additionalSetting?.allowMultipleAttachments || false,
            allowComments: fetchedQuestion.additionalSetting?.allowComments || false,
            uploadSignatureFile: fetchedQuestion.additionalSetting?.uploadSignatureFile || false,
            drawSignature: fetchedQuestion.additionalSetting?.drawSignature || false,
            description: fetchedQuestion.additionalSetting?.description || "",
            dimitraModule,
            getData: {
              condition: null,
              getData: {
                score: fetchedQuestion.score || 0,
                expanded: false,
                dataFields: (fetchedQuestion.getData || []).map((gd) => this.transformGetData(gd)),
              },
              flags: {
                getData: fetchedQuestion.getData.length > 0 ? true : false,
              },
            },
            options: fetchedOptions.map((option) => ({
              _id: option._id,
              title: option.label,
              score: option.score || 0,
              actions: [],
              expanded: false,
              recommendations: option.recommendation || "",
              flags: {
                recommendations: !!option.isRecommendationEnabled,
                getData: !!option.isGetDataEnabled,
                actionPlan: !!option.isActionPlanEnabled,
                dimitraModules: !!option.isDimitraModulesEnabled,
              },
              condition: (option.isRecommendationEnabled && option.isGetDataEnabled && option.isActionPlanEnabled) ? "All": "Any",
               getData: {
                score: option.getDataScore || 0,
                expanded: false,
                dataFields: (option.getData || []).map((gd) => ({
                  _id: gd._id,
                  ...this.transformGetData(gd),
                })),
              },
              actionPlan: {
                score: option.actionPlanScore || 0,
                items: (option.actionPlans || []).map((plan) => ({
                  _id: plan._id,
                  item: plan.title,
                  requireFile: plan.isFileRequired,
                })),
              },
            dimitraModule: (option.dimitraModules && option.dimitraModules.length > 0) ? option.dimitraModules[0] : {},
            })),
            repeat: {
              enabled: fetchedQuestion.isRepeatEnabled || false,
              type: fetchedQuestion.repeatType || "Fixed",
              selectedDates: fetchedQuestion.repetitionDates || [],
              fixedStartDate: null,
              fixedRepeatType: fetchedQuestion.repetitionPeriod || "Month",
              fixedRepetitions: fetchedQuestion.repetitionCount || 0,
            },
          };
          this.sanitizeQuestionConfiguration();
      } catch (error) {
        console.error("Failed to fetch question:", error);
      }
    },
    getActionName(option) {
      if (option.expanded) {
        return "Close Action";
      }

      return option.actions.length > 0 ? "Edit Actions": "Add Actions";
    },
    getActionChevron(option) {
      return option.expanded ? "mdi-chevron-up": "mdi-chevron-down";
    },
   
    async addOption() {
      if (!this.newOption || this.newOption.length === 0) { return; }
        try {
          const newOption = {
            title: this.newOption,
            score: null,
            actions: [],
            expanded: false,
            condition: 'Any',
            recommendations: "",
            actionPlanScore: 0,
            getDataScore: 0,
            flags: {
              recommendations: false,
              getData: false,
              actionPlan: false,
              dimitraModules: false,
            },
            getData: {
              score: null,
              expanded: false,
              dataFields: []
            },
            actionPlan: {
              score: null,
              items: []
            },
            dimitraModule: {},
          };

          if (this.isEdit) {
            const payload = {
              label: this.newOption,
              score: 0,
              recommendation: "",
              isDimitraModulesEnabled: false,
              isActionPlanEnabled: false,
              isGetDataEnabled: false,
              isRecommendationEnabled: false,
              esgAssessmentQuestionId: this.question._id,
              orgId: this.getOrganizationId,
              createdBy: this.getUserId,
            };

            const response = await EsgService.createAssessmentQuestionOption(payload);

            if (response.success) {
              newOption._id = response.data._id;
              this.$notify({ title: this.$t('esgPlatform.optionAdded'), text: this.$t('esgPlatform.optionAddedSuccess'), type: "success" });
            } else {
              throw new Error(response.message);
            }
          }

          this.question.options.push(newOption);
          this.newOption = null;
          
        } catch (error) {
          console.error("Error adding option:", error);
          this.$notify({ title: this.$t('esgPlatform.error'), text: this.$t('esgPlatform.failedToAddOption'), type: "error" });
      }
    },
    async addAction(option) {
      console.log(option)
      try {
        const newAction = {
          item: this.newActionPlan,
          requireFile: false,
        };

        if (this.isEdit) {
          const payload = {
            title: this.newActionPlan,
            isFileRequired: false,
            esgAssessmentQuestionId: this.question._id,
            esgAssessmentQuestionOptionId: option._id,
            orgId: this.getOrganizationId,
            createdBy: this.getUserId,
          };

          const response = await EsgService.createActionPlan(payload);
          if (response.success) {
            newAction._id = response.data._id;
            option.actionPlan.items.push(newAction);
            this.$notify({ title: this.$t('esgPlatform.actionPlan'), text: this.$t('esgPlatform.actionPlanCreatedSuccess'), type: "success" });
          } else {
            throw new Error(response.message);
          }
        } else {
          option.actionPlan.items.push(newAction);
        }

        this.newActionPlan = null;
      } catch (error) {
        console.error("Error creating action plan:", error);
        this.$notify({ title: this.$t('esgPlatform.error'), text: this.$t('esgPlatform.failedToCreateActionPlan'), type: "error" });
      }
    },
    async updateActionPlan(option, actionPlan) {
      try {
        if (!this.isEdit) return;

        const payload = {
          title: actionPlan.item,
          isFileRequired: actionPlan.requireFile,
        };

        const response = await EsgService.updateActionPlan(actionPlan._id, payload);
        if (response.success) {
          this.$notify({ title: this.$t('success'), text: this.$t('esgPlatform.actionPlanUpdatedSuccess'), type: "success" });
        } else {
          throw new Error(response.message);
        }
      } catch (error) {
        console.error("Error updating action plan:", error);
        this.$notify({ title: this.$t('esgPlatform.error'), text: this.$t('esgPlatform.failedToUpdateActionPlan'), type: "error" });
      }
    },
    expandOption(option) {
      option.expanded = !option.expanded;
    },
    closeModal() {
      this.$emit("closeDialog");
    },
    async removeDataField(getDataId, isMainGetData = false, optionId = null) {
      try {
        await EsgService.deleteGetDataQuestion(getDataId);
        this.$notify({ title: this.$t('esgPlatform.dataField'), text: this.$t('esgPlatform.dataFieldDeletedSuccess'), type: "success" });

        // Remove from main getData block
        if (isMainGetData) {
          const list = this.question.getData.getData.dataFields;
          const index = list.findIndex(df => df._id === getDataId);
          if (index !== -1) list.splice(index, 1);
        }

        // Remove from option-level getData block
        if (optionId) {
          const option = this.question.options.find(o => o._id === optionId);
          if (option?.getData?.dataFields) {
            const index = option.getData.dataFields.findIndex(df => df._id === getDataId);
            if (index !== -1) option.getData.dataFields.splice(index, 1);
          }
        }
      }catch (error) {
        console.error("Error deleting data field:", error);
        this.$notify({ title: this.$t('esgPlatform.error'), text: this.$t('esgPlatform.failedToDeleteDataField'), type: "error" });
      }
    },
    typeToTitle(type) {
      return type?.replaceAll("-", " ");
    },
    showDatafieldModal(source, isEdit = false, questionOptionId = null) {
      const ids = {
        questionOptionId: isEdit ? questionOptionId : source._id,
        questionId: this.selectedQuestion,
        surveyId: this.surveyId,
      };

      if (!source) {
          console.error("Error: source is undefined in showDatafieldModal");
          return;
      }

      if (!source.getData) {
          source.getData = { dataFields: [] };
      }

      this.datafieldSource = source;
      this.selectedDataField = isEdit ? { ...source, datatype: source.dataType, ids } : { ids };
      this.dataFieldEdit = isEdit;
      this.datafieldModal = true;
    },
    addDataField(df) {
      if (!this.datafieldSource || !this.datafieldSource.getData) {
          console.error("datafieldSource or getData is null!");
          return;
      }

      if (this.dataFieldEdit) {
          const index = this.datafieldSource.getData.dataFields.findIndex(d => d._id === df._id);
          if (index !== -1) {
              this.datafieldSource.getData.dataFields[index] = df;
          }
      } else {
          this.datafieldSource.getData.dataFields.push(df);
      }

      this.datafieldModal = false;
    },
    editDataField(field, optionId) {
        this.showDatafieldModal(field, true, optionId);
    },
    saveCustomDate(date) {
      this.question.repeat.selectedDates.push(date);
      this.selectedCustomDate = null;
      this.dateModalCustom = false;
    },
    saveStartDate(date) {
      try {
        const reps = Number.parseInt(this.question.repeat.fixedRepetitions);

        if (isNaN(reps) || reps === null || reps === undefined) {
          return; // Return on 0 repetitions
        }

        this.question.repeat.fixedStartDate = date;
        this.question.repeat.selectedDates = [];
        this.question.repeat.selectedDates.push(date);

        const repFunctions = {
          day: (date) => {
            return new Date(date.getTime() + 86400000);
          },
          week: (date) => {
            return new Date(date.getTime() + (86400000 * 7));
          },
          month: (date) => {
            return new Date(date.setMonth(date.getMonth() + 1));
          },
          quarter: (date) => {
            return new Date(date.setMonth(date.getMonth() + 4));
          },
          year: (date) => {
            return new Date(date.setFullYear(date.getFullYear() + 1));
          }
        }

        const startDate = new Date(date);
        for (let i = 0; i < reps; i++) {
          const repFunction = repFunctions[this.question.repeat.fixedRepeatType.toLowerCase()];
          this.question.repeat.selectedDates.push(repFunction(startDate).toISOString().split("T")[0]);
        }
        this.dateModalFixed = false;
      } catch (e) {
        console.log("Invalid value for reps!")
      }
    },
    clearSelectedDates() {
      this.question.repeat.selectedDates = [];
    },
    deleteCustomDate(idx) {
      if (!this.question.repeat.selectedDates) {
        console.error("Error: selectedDates is undefined!");
        return;
      }

      if (idx >= 0 && idx < this.question.repeat.selectedDates.length) {
        this.question.repeat.selectedDates.splice(idx, 1);
      } else {
        console.error("Error: Invalid index for selectedDates");
      }
    },
    isOptionType() {
      return ["radio-button", "check-boxes"].includes(this.question.questionType);
    },
    openPreview() {
      const question = {
        title: this.question.title,
        type: this.question.questionType,
        drawSignature: this.question.drawSignature,
        uploadSignatureFile: this.question.uploadSignatureFile,
        options: (this.question.options || []).map((op) => op.title)
      }

      this.previewQuestions = [question];
      this.showPreview = true;
    },
    closePreview() {
      this.showPreview = false;
      this.previewQuestions = [];
    },
    openGetDataPreview(option) {
      const questions = (option?.getData?.dataFields || []).map((df) => ({
        title: df.title,
        type: df.datatype,
        helpEnabled: df.helpEnabled,
        help: df.help,
        unit: df.measurementUnit,
        options: (df.options || []).map((op) => op.label)
      }));
      
      this.previewQuestions = questions;
      console.log(this.previewQuestions);
      this.showPreview = true;
    },
    parseScore(value) {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : 0;
    },
    getMaxConditionScoreForPayload(conditions = []) {
      if (!Array.isArray(conditions) || !conditions.length) {
        return 0;
      }
      return conditions.reduce((maxScore, condition) => {
        const normalized = this.parseScore(condition?.score);
        return normalized > maxScore ? normalized : maxScore;
      }, 0);
    },
    calculateDimitraScoreForPayload(moduleConfig = {}) {
      const progressMetrics = moduleConfig?.progressMetrics || {};
      const rules = Array.isArray(progressMetrics.rules) ? progressMetrics.rules : [];
      const enabledRules = rules.filter((rule) => rule?.enabled !== false);
      const progressMetricsTotal = enabledRules.reduce((total, rule) => {
        return total + this.getMaxConditionScoreForPayload(rule?.conditions);
      }, 0);
      const yearOnYear = progressMetrics.yearOnYear || {};
      const yearOnYearMax = yearOnYear.enabled ? this.getMaxConditionScoreForPayload(yearOnYear.conditions) : 0;

      return progressMetricsTotal + yearOnYearMax;
    },
    applySurveyRespondentAppToDimitraPayload(modulePayload = {}) {
      const app = getDimitraAppForRespondentType(this.surveyRespondentType);
      if (app) {
        modulePayload.app = app;
      }
      return modulePayload;
    },
    getDimitraModulePayload() {
      const modulePayload = JSON.parse(JSON.stringify(this.question.dimitraModule || {}));

      if ( modulePayload.fieldsByModule && typeof modulePayload.fieldsByModule === "object" &&
         !Array.isArray(modulePayload.fieldsByModule) ) {

        const flattenFieldsForPayload = (fields = [], { inheritedGroupKey = null } = {}) => {
          const flattened = [];
          (fields || []).forEach((field) => {
            if (!field || typeof field !== "object" || Array.isArray(field)) {
              return;
            }
            if (!field?.key) {
              return;
            }

            const isChild = !!field.isChild || !!inheritedGroupKey;
            const groupKey = field.groupKey || inheritedGroupKey || null;
            const sanitized = {
              key: field?.key,
              type: field?.type,
              isEnabled: field?.isEnabled,
              value: field?.value || null,
            };
            if (isChild) {
              sanitized.isChild = true;
              sanitized.groupKey = groupKey;
            }
            flattened.push(sanitized);

            if (Array.isArray(field?.children) && field.children.length) {
              flattened.push(
                ...flattenFieldsForPayload(field.children, { inheritedGroupKey: field.key })
              );
            }
          });
          return flattened;
        };

        Object.keys(modulePayload.fieldsByModule).forEach((moduleName) => {
          const moduleFields = modulePayload.fieldsByModule[moduleName];
          if (!Array.isArray(moduleFields)) { return; }
          modulePayload.fieldsByModule[moduleName] = flattenFieldsForPayload(moduleFields);
        });
      }

      if (Object.prototype.hasOwnProperty.call(modulePayload, "score")) {
        delete modulePayload.score;
      }
      if (Object.prototype.hasOwnProperty.call(modulePayload, "activeModuleIndex")) {
        delete modulePayload.activeModuleIndex;
      }
      if (Object.prototype.hasOwnProperty.call(modulePayload, "selectionAction")) {
        delete modulePayload.selectionAction;
      }
      if (Object.prototype.hasOwnProperty.call(modulePayload, "expanded")) {
        delete modulePayload.expanded;
      }
      return this.applySurveyRespondentAppToDimitraPayload(modulePayload);
    },
    getOptionDimitraModulePayload(optionModule = {}) {
      const modulePayload = JSON.parse(JSON.stringify(optionModule || {}));

      if (Object.prototype.hasOwnProperty.call(modulePayload, "progressMetrics")) {
        delete modulePayload.progressMetrics;
      }

      if (
        modulePayload.fieldsByModule &&
        typeof modulePayload.fieldsByModule === "object" &&
        !Array.isArray(modulePayload.fieldsByModule)
      ) {
        const flattenOptionFieldsForPayload = (fields = [], { inheritedGroupKey = null } = {}) => {
          const flattened = [];
          (fields || []).forEach((field) => {
            if (!field || typeof field !== "object" || Array.isArray(field)) {
              return;
            }
            if (!field?.key) {
              return;
            }

            const isChild = !!field.isChild || !!inheritedGroupKey;
            const groupKey = field.groupKey || inheritedGroupKey || null;
            const sanitized = {
              key: field?.key,
              type: field?.type,
              isEnabled: field?.isEnabled,
              value: field?.value || null,
            };
            if (isChild) {
              sanitized.isChild = true;
              sanitized.groupKey = groupKey;
            }
            flattened.push(sanitized);

            if (Array.isArray(field?.children) && field.children.length) {
              flattened.push(
                ...flattenOptionFieldsForPayload(field.children, { inheritedGroupKey: field.key })
              );
            }
          });
          return flattened;
        };

        Object.keys(modulePayload.fieldsByModule).forEach((moduleName) => {
          const moduleFields = modulePayload.fieldsByModule[moduleName];
          if (!Array.isArray(moduleFields)) {
            return;
          }

          modulePayload.fieldsByModule[moduleName] = flattenOptionFieldsForPayload(moduleFields);
        });
      }

      return this.applySurveyRespondentAppToDimitraPayload(modulePayload);
    },
    shouldSanitizeOptionDimitraModule() {
      return ["radio-button", "radio-buttons", "check-boxes"].includes(this.question.questionType);
    },
    getQuestionScoreForPayload() {
      if (this.isDimitraModule && this.question.scoreEnabled) {
        const finalScore = this.calculateDimitraScoreForPayload(this.question.dimitraModule || {});
        this.question.score = finalScore;
        return finalScore;
      }
      if (this.hasQuestionLevelScore) {
        return this.parseScore(this.question.score);
      }
      return this.parseScore(this.question.getData?.getData?.score);
    },
    async saveQuestion() {
      if(this.isEdit) {
        await this.updateQuestion();
      } else {
        await this.submitQuestion();
      }
    },
    async submitQuestion() {
      try {
        this.startLoading();

        // Validate that a heading is selected
        if (!this.question.esgHeadingId) {
          this.$notify({
            title: this.$t('esgPlatform.validationError'),
            text: this.$t('esgPlatform.pleaseSelectHeadingBeforeSubmitting'),
            type: "error",
          });
          this.stopLoading();
          return;
        }

        this.applyParentLockedQuestionFields();
        this.sanitizeQuestionConfiguration();
        if (!this.validateQuestionAudience()) {
          this.stopLoading();
          return;
        }
        const scoreEnabledForPayload = this.getQuestionFieldValueForPayload("scoreEnabled");
        const respondentTypeForPayload = this.getQuestionFieldValueForPayload("answerer");
        const repeatEnabledForPayload = this.getQuestionFieldValueForPayload("repeatEnabled");

        const questionPayload = {
          esgAssessmentId: this.surveyId,
          esgHeadingId: this.question.esgHeadingId,
          createdBy: this.getUserId,
          title: this.question.title,
          questionType:this.question.questionType,
          isMandatory: this.question.isMandatory,
          score: this.getQuestionScoreForPayload(),
          isScoreEnabled: scoreEnabledForPayload,
          respondentType: respondentTypeForPayload,
          orgId: this.getOrganizationId,
          isRepeatEnabled: repeatEnabledForPayload,
          repeatType: this.question.repeat.type || "Fixed",
          repetitionPeriod: this.question.repeat.fixedRepeatType || "Month",
          repetitionCount: this.question.repeat.fixedRepetitions || 0,
          repetitionDates: this.question.repeat.selectedDates || [],

          additionalSetting: {
            description: this.question.description || "",
            ...(this.question.questionType === "attach-files" && {
              allowedFileTypes: this.question.allowedFileTypes || [],
              allowMultipleAttachments: this.question.allowMultipleAttachments || false,
              allowComments: this.question.allowComments || false,
            }),
            ...(this.question.questionType === "digital-signature" && {
              uploadSignatureFile: this.question.uploadSignatureFile || false,
              drawSignature: this.question.drawSignature || false,
            }),
          },
          ...(this.isDimitraModule && { dimitraModule: this.getDimitraModulePayload(), }),
        };
        if (this.question.questionType === "get-data" && this.question.getData?.getData?.dataFields.length) {
          questionPayload.getData = this.question.getData.getData.dataFields.map((dataField) => ({
            dataType: dataField.dataType,
            title: dataField.title,
            isMandatory: dataField.isMandatory,
            optionValues: dataField.optionValues || [],
            helpText: dataField.helpText || "",
            helpEnabled: dataField.helpEnabled || false,
            additionalSettings: dataField.additionalSettings,
            orgId: this.getOrganizationId,
            createdBy: this.getUserId,
          }));
        }

        // Prepare Options with GetData & Action Plans
        const optionsPayload = this.question.options.map((option) => {
          const flags = this.getSanitizedOptionActionFlags(option);
          const payload = {
            label: option.title,
            score: option.score || 0,
            recommendation: flags.recommendations ? (option.recommendations || "") : "",
            isActionPlanEnabled: flags.actionPlan,
            isGetDataEnabled: flags.getData,
            isRecommendationEnabled: flags.recommendations,
            isDimitraModulesEnabled: flags.dimitraModules,
            actionPlanScore: flags.actionPlan ? (option.actionPlan.score || 0) : 0,
            getDataScore: flags.getData ? (option.getData.score || 0) : 0,
            actionPlans: flags.actionPlan
              ? option.actionPlan.items.map((plan) => ({
                  title: plan.item,
                  isFileRequired: plan.requireFile,
                  orgId: this.getOrganizationId,
                  createdBy: this.getUserId,
                }))
              : [],
            getData: flags.getData
              ? option.getData.dataFields.map((dataField) => ({
                  dataType: dataField.dataType,
                  title: dataField.title,
                  isMandatory: dataField.isMandatory,
                  optionValues: dataField.optionValues || [],
                  helpText: dataField.helpText || "",
                  helpEnabled: dataField.helpEnabled || false,
                  additionalSettings: dataField.additionalSettings,
                  orgId: this.getOrganizationId,
                  createdBy: this.getUserId,
                }))
              : [],
          };
          if (flags.dimitraModules) {
            payload.dimitraModule = this.shouldSanitizeOptionDimitraModule()
              ? this.getOptionDimitraModulePayload(option.dimitraModule)
              : (option.dimitraModule || {});
          }
          return payload;
        });

        const finalPayload = {
          question: questionPayload,
          options: optionsPayload,
        };

        console.log("Final Payload:", finalPayload);

        const response = await EsgService.submitAssessmentQuestion(finalPayload);
        console.log("Question submitted successfully:", response);

        if(response.success && (response.code === 200 || response.code === 201)) {
          this.$notify({
              title: this.$t('esgPlatform.questionSubmittedSuccessfully'),
              text: response.message || '',
              type: "success",
            });
          this.closeModal();
        } else {
          this.$notify({
            title: this.$t('esgPlatform.errorSubmittingAssessmentQuestion'),
            text: response.message || '',
            type: "error",
          });
        }
      } catch (error) {
        console.error("Error submitting assessment question:", error);
        this.$notify({
          title: "Error submitting assessment question",
          message: error,
          type: "error",
        });
      } finally {
        this.stopLoading();
      }
    },
    async updateQuestion() {
      try {
        this.startLoading();

        if (!this.question.esgHeadingId) {
          this.$notify({
            title: this.$t('esgPlatform.validationError'),
            text: this.$t('esgPlatform.pleaseSelectHeadingBeforeSubmitting'),
            type: "error",
          });
          this.stopLoading();
          return;
        }

        this.applyParentLockedQuestionFields();
        this.sanitizeQuestionConfiguration();
        if (!this.validateQuestionAudience()) {
          this.stopLoading();
          return;
        }
        const scoreEnabledForPayload = this.getQuestionFieldValueForPayload("scoreEnabled");
        const respondentTypeForPayload = this.getQuestionFieldValueForPayload("answerer");
        const repeatEnabledForPayload = this.getQuestionFieldValueForPayload("repeatEnabled");

        const questionPayload = {
          esgAssessmentId: this.surveyId,
          esgHeadingId: this.question.esgHeadingId,
          createdBy: this.getUserId,
          score: this.getQuestionScoreForPayload(),
          title: this.question.title,
          questionType: this.question.questionType,
          isMandatory: this.question.isMandatory,
          isScoreEnabled: scoreEnabledForPayload,
          respondentType: respondentTypeForPayload,
          orgId: this.getOrganizationId,
          isRepeatEnabled: repeatEnabledForPayload,
          repeatType: this.question.repeat.type || "Fixed",
          repetitionPeriod: this.question.repeat.fixedRepeatType || "Month",
          repetitionCount: this.question.repeat.fixedRepetitions || 0,
          repetitionDates: this.question.repeat.selectedDates || [],

          additionalSetting: {
            description: this.question.description || "",
            ...(this.question.questionType === "attach-files" && {
              allowedFileTypes: this.question.allowedFileTypes || [],
              allowMultipleAttachments: this.question.allowMultipleAttachments || false,
              allowComments: this.question.allowComments || false,
            }),
            ...(this.question.questionType === "digital-signature" && {
              uploadSignatureFile: this.question.uploadSignatureFile || false,
              drawSignature: this.question.drawSignature || false,
            }),
          },
          ...(this.isDimitraModule && {
            dimitraModule: this.getDimitraModulePayload(),
          }),
        };

        if (this.question.questionType === "get-data" && this.question.getData?.getData?.dataFields.length) {
          questionPayload.getData = this.question.getData.getData.dataFields.map((dataField) => ({
            dataType: dataField.dataType,
            title: dataField.title,
            isMandatory: dataField.isMandatory,
            optionValues: dataField.optionValues || [],
            helpText: dataField.help || "",
            helpEnabled: dataField.helpEnabled || false,
            additionalSettings: dataField.additionalSettings,
            orgId: this.getOrganizationId,
            createdBy: this.getUserId,
          }));
        }

        const optionsPayload = this.question.options.map((option) => {
          const flags = this.getSanitizedOptionActionFlags(option);
          const payload = {
            _id: option._id,
            label: option.title,
            score: option.score || 0,
            recommendation: flags.recommendations ? (option.recommendations || "") : "",
            isActionPlanEnabled: flags.actionPlan,
            isGetDataEnabled: flags.getData,
            isRecommendationEnabled: flags.recommendations,
            isDimitraModulesEnabled: flags.dimitraModules,
            actionPlanScore: flags.actionPlan ? (option.actionPlan.score || 0) : 0,
            getDataScore: flags.getData ? (option.getData.score || 0) : 0,
          };

          if (flags.dimitraModules) {
            payload.dimitraModule = this.shouldSanitizeOptionDimitraModule()
              ? this.getOptionDimitraModulePayload(option.dimitraModule)
              : (option.dimitraModule || {});
          }
          return payload;
        });

        const finalPayload = {
          question: questionPayload,
          options: optionsPayload,
        };

        console.log("Final Payload:", finalPayload);

        const response = await EsgService.updateAssessmentQuestion(this.question._id,finalPayload);
        console.log("Question submitted successfully:", response);

        if (response.success && (response.code === 200 || response.code === 201)) {
          this.$notify({
            title: "Question submitted successfully",
            text: response.message || '',
            type: "success",
          });
          this.closeModal();
        } else {
          this.$notify({
            title: this.$t('esgPlatform.errorSubmittingAssessmentQuestion'),
            text: response.message || '',
            type: "error",
          });
        }
      } catch (error) {
        console.error("Error submitting assessment question:", error);
        this.$notify({
          title: "Error submitting assessment question",
          message: error,
          type: "error",
        });
      } finally {
        this.stopLoading();
      }
    }
  },
  mixins: [loadingMixin],
};
</script>

<style lang="scss" scoped>
/* Transparent wrapper: when `disabled`, native form controls inside are
   disabled (view-only), while `display: contents` keeps the layout unchanged. */
.vq-readonly-fieldset {
  display: contents;
  border: 0;
  margin: 0;
  padding: 0;
  min-width: 0;
}

.pointer {
  cursor: pointer;
}

.h3 {
  font-size: 1.2em;
  font-weight: bold;
}

.h4 {
  font-size: 1.1em;
  font-weight: bold;
}

.bottomless {
  background-color: white;
}

::v-deep .v-data-table-header__icon {
  color: white !important;
}

::v-deep .bottomless .v-input__slot {
  margin-bottom: 0 !important;
}

::v-deep .bottomless .v-messages {
  display: none !important;
}

::v-deep .v-text-field__details {
  display: none !important;
}

::v-deep .options .v-card__title {
  font-size: 1em;
  font-weight: 900;
  color: white;
  background-color: $primary-color;
  border-radius: 8px !important;
}

::v-deep .options.dark .v-card__title {
  background-color: rgb(66, 66, 66) !important;
}

.right-border-col {
  border-right: 1px solid rgb(112, 112, 112);
}

.answerer-select {
  width: 450px;
}

.option {
  background-color: rgb(233, 233, 233);
  border-radius: 8px;
}

.content-col {
  display: flex;
  align-items: center;
}

.w-100 {
  width: 100%;
  height: 100%;
}

.clickable {
  color: $primary-color;
  cursor: pointer;
}

.expandable {
  background-color: white;
  border-radius: 8px !important;
}

h3, h4 {
  color: black;
}

::v-deep .v-label {
  font-size: 0.8em !important;
}

.seperator {
  background-color: lightgray;
  height: 2px;
  border: none;
  margin-top: 1rem;
  margin-bottom: 1.5rem;
}
.text--small {
  font-size: 0.8em;
}

.question-footer {
  display: flex;
  flex-direction: row;
  justify-content: end;
  gap: 20px;
}
</style>
